import OrderDetailsModal from './OrderDetailsModal';

export default OrderDetailsModal;
